import { render } from "./ProductsList.vue?vue&type=template&id=4ee9d05c&ts=true"
import script from "./ProductsList.ts?vue&type=script&lang=ts&external"
export * from "./ProductsList.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__